import React, { useEffect, useState, useContext, useCallback } from "react";
import "./FastPok.scss";
import {
  Form,
  ButtonGroup,
  ToggleButton,
  InputGroup,
  OverlayTrigger,
  FormControl,
  Button,
  Tooltip
} from "react-bootstrap";
import RangeSlider from "react-bootstrap-range-slider";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useTranslation } from "react-i18next";

import {
  getVilainPositionsForNbPlayers,
  getHeroPositionsForNbPlayers,
  getPositionsForNbPlayers
} from "./FastPokVariables";
import { POKTOOLS_API_URL, reorderPositions } from "../PoktoolsVariables";
import { getTrainerCard } from "../trainer/TrainerVariables";
import { LoadingContext } from "../../../api/loading/LoadingContext";
import { Cards, nFormatter } from "../../../api/ReplayVariables";
import { PoktoolsContext } from "../poktoolsContext";
import { UserContext } from "../../../api/user/userContext";
import InitData from "./FastPokInitData.json";

const Loading = require("react-loading-animation");

function FastPok({ match, history, onShowLogin }) {
  const { user } = useContext(UserContext);
  const { poktoolsState, dispatchPoktoolsState } = useContext(PoktoolsContext);
  const [situation, setSituation] = useState("");
  const [players, setPlayers] = useState(0);
  const [positionVilain, setPositionVilain] = useState("");
  const [positionHero, setPositionHero] = useState("");
  const [stack, setStack] = useState(0);
  const [ante, setAnte] = useState(0);

  const getCellCards = (cell) => {
    let suited = cell.hand.toLowerCase().endsWith("s");
    let _cards = [];
    for (let i = 0; i < 2; i++) {
      _cards.push(getTrainerCard(cell.hand.substring(i, i + 1), i + 1, suited));
    }
    return _cards;
  };

  const parseData = (resp) => {
    //console.info("parsing resp", resp);
    let _data = [];
    let row = [];
    _data.push(row);
    let index = 0;
    for (let k = 0; k < 169; k++) {
      let cell = resp.fastpokResult["" + k];
      //console.debug("cell", cell);
      row.push(cell);
      index++;
      if (index === 13) {
        index = 0;
        row = [];
        _data.push(row);
      }
    }
    //setSelectedCell(_data[0][0]);
    return _data;
  };

  const [data, setData] = useState([]);
  const [range, setRange] = useState(InitData.range_percent_play);
  const { loading, dispatchLoading } = useContext(LoadingContext);
  const [selectedCell, setSelectedCell] = useState(
    InitData.data.fastpokResult[0]
  );
  const [selectedCards, setSelectedCards] = useState(
    getCellCards(selectedCell)
  );

  const _answers = {};
  _answers[JSON.stringify(InitData.key)] = InitData.data;
  const [answers, setAnswers] = useState(_answers);

  const handleStackChange = (value) => {
    //console.log("handleStackChange", value);
    if (value.length > 0 && value <= 20) {
      history.push(
        "/app/poktools/fastpok/form/" +
          match.params.situation +
          "/" +
          match.params.players +
          "/" +
          match.params.positionVilain +
          "/" +
          match.params.positionHero +
          "/" +
          value +
          "/" +
          match.params.ante
      );
    }
  };

  const handleAnteChange = (value) => {
    if (value.length > 0 && value >= 0) {
      history.push(
        "/app/poktools/fastpok/form/" +
          match.params.situation +
          "/" +
          match.params.players +
          "/" +
          match.params.positionVilain +
          "/" +
          match.params.positionHero +
          "/" +
          match.params.stack +
          "/" +
          value
      );
    }
  };

  const doSetSelectedCell = useCallback((cell) => {
    setSelectedCards(getCellCards(cell));
    setSelectedCell(cell);
  }, []);

  const { t } = useTranslation();

  const showError = useCallback(
    (message) => {
      toast.error(t("poktools.error") + " : " + message, {
        position: "bottom-right",
        autoClose: 10000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: 0
      });
      dispatchLoading({ type: "update", payload: 100 });
    },
    [dispatchLoading, t]
  );

  const saveParams = useCallback(() => {
    setSituation(match.params.situation);
    setPlayers(match.params.players);
    setPositionHero(match.params.positionHero);
    setPositionVilain(match.params.positionVilain);
    setStack(match.params.stack);
    setAnte(match.params.ante);
  }, [
    match.params.ante,
    match.params.players,
    match.params.positionHero,
    match.params.positionVilain,
    match.params.situation,
    match.params.stack
  ]);

  const analyseData = useCallback(() => {
    let key = {
      situation: match.params.situation,
      player: match.params.players,
      positionHero: match.params.positionHero,
      stack: match.params.stack,
      ante: match.params.ante
    };
    if (match.params.situation === "call_push") {
      let vilains = reorderPositions(match.params.positionVilain.split(","));
      key["positionVilain"] = vilains;
    } else {
      key["positionVilain"] = "CO";
    }
    console.log("key", JSON.stringify(key));
    if (answers[JSON.stringify(key)]) {
      console.log("in memory");
      let _data = parseData(answers[JSON.stringify(key)]);
      saveParams();
      setData((da) => _data);
      doSetSelectedCell(_data[0][0]);
      dispatchLoading({ type: "update", payload: 100 });
      return;
    }
    //FETCH HAND DETAILS
    console.log("not in memory");
    dispatchLoading({ type: "update", payload: 10 });
    axios({
      method: "post",
      headers: {
        "X-USER-POKTOOLS": poktoolsState.xUserPoktools,
        "X-PARTNER-POKTOOLS": poktoolsState.xPartnerPoktools,
        "X-PASS-POKTOOLS": poktoolsState.xPassPoktools,
        "x-xeester-licence": poktoolsState.xXeesterLicence,
        Accept: "*/*",
        "content-type": "application/x-www-form-urlencoded"
      },
      params: key,
      mode: "cors",
      url: POKTOOLS_API_URL + "fastpok"
    })
      .then((resp) => {
        console.log("resp", resp);
        if (resp.data.errorCode) {
          dispatchLoading({ type: "update", payload: 100 });
          showError("FETCH");
        } else {
          let parsedData = parseData(resp.data);
          console.debug("parsed", parsedData);
          setData((da) => parsedData);
          doSetSelectedCell(parsedData[0][0]);
          setRange((r) => resp.data.fastpokResult.range_percent_play);
          let _answers = JSON.parse(JSON.stringify(answers));
          _answers[JSON.stringify(key)] = resp.data;
          setAnswers((a) => _answers);
          saveParams();
          dispatchLoading({ type: "update", payload: 100 });
        }
      })
      .catch((err) => {
        console.error("fetch problem", err);
        dispatchLoading({ type: "update", payload: 100 });
        showError("FETCH");
      });
  }, [
    answers,
    dispatchLoading,
    doSetSelectedCell,
    match.params.ante,
    match.params.players,
    match.params.positionHero,
    match.params.positionVilain,
    match.params.situation,
    match.params.stack,
    poktoolsState.xPartnerPoktools,
    poktoolsState.xPassPoktools,
    poktoolsState.xUserPoktools,
    poktoolsState.xXeesterLicence,
    saveParams,
    showError
  ]);

  const showLogin = useCallback(() => {
    onShowLogin();
  }, [onShowLogin]);

  const getCellForeground = (bg) => {
    let rgb = bg.replace("rgb(", "").replace(")", "").split(",");
    const brightness = Math.round(
      (parseInt(rgb[0].trim()) * 299 +
        parseInt(rgb[1].trim()) * 587 +
        parseInt(rgb[2].trim()) * 114) /
        1000
    );
    return brightness > 125 ? "black" : "white";
  };

  useEffect(() => {
    let urls = {
      home: window.poktoolsLastUrls.home,
      trainer: window.poktoolsLastUrls.trainer,
      fastpok: window.poktoolsLastUrls.fastpok,
      rp: window.poktoolsLastUrls.rp
    };
    urls.fastpok = document.location.href.substring(
      document.location.href.indexOf("/app/poktools/")+ 14
    );
    window.poktoolsLastUrls = urls;

    dispatchLoading({ type: "update", payload: 100 });
  }, [
    data,
    dispatchLoading,
    dispatchPoktoolsState,
    match.params.tab,
    poktoolsState.xPassPoktools,
    poktoolsState.xUserPoktools,
    showLogin,
    user.crypt,
    user.error
  ]);

  return (
    <div id="fastpok">
      <PerfectScrollbar>
        <ToastContainer
          position="bottom-left"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover={false}
        />
        <div
          className={
            "fastpok-loading-container" +
            (loading.progress === 100 ? " done" : "")
          }
        >
          <div>
            <Loading></Loading>
          </div>
        </div>
        <div id="fastpok-top">
          <div id="fastpok-container" className="align-top">
            <Form className="poktools-form">
              <section>
                <div
                  className="back"
                  onClick={() => {
                    history.push("/app/poktools/home");
                  }}
                >
                  &lt; <span className="back-text">{t("poktools.back")}</span>
                </div>
                {t("poktools.fastpok.situation.title")}
              </section>
              <div className="select-row">
                <ButtonGroup
                  toggle
                  type="checkbox"
                  value={match.params.situation}
                >
                  <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 250, hide: 250 }}
                    overlay={(props) => (
                      <Tooltip id="button-tooltip" {...props}>
                        {t("poktools.fastpok.open_push")}
                      </Tooltip>
                    )}
                  >
                    <ToggleButton
                      type="radio"
                      checked={match.params.situation === "open_push"}
                      value={1}
                    >
                      {match.params.situation === "open_push" ? (
                        <a href="#done" alt="">
                          Open Push
                        </a>
                      ) : (
                        <Link
                          to={
                            "/app/poktools/fastpok/form/open_push/" +
                            match.params.players +
                            "/-1/-1/" +
                            match.params.stack +
                            "/" +
                            match.params.ante
                          }
                        >
                          Open Push
                        </Link>
                      )}
                    </ToggleButton>
                  </OverlayTrigger>
                  <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 250, hide: 250 }}
                    overlay={(props) => (
                      <Tooltip id="button-tooltip" {...props}>
                        {t("poktools.fastpok.call_push")}
                      </Tooltip>
                    )}
                  >
                    <ToggleButton
                      type="radio"
                      checked={match.params.situation === "call_push"}
                      value={2}
                    >
                      {match.params.situation === "call_push" ? (
                        <a href="#done">Call vs Push</a>
                      ) : (
                        <Link
                          to={
                            "/app/poktools/fastpok/form/call_push/" +
                            match.params.players +
                            "/-1/-1/" +
                            match.params.stack +
                            "/" +
                            match.params.ante
                          }
                        >
                          Call vs Push
                        </Link>
                      )}
                    </ToggleButton>
                  </OverlayTrigger>
                </ButtonGroup>
              </div>
              <section>{t("poktools.fastpok.players.title")}</section>
              <div className="select-row">
                <ButtonGroup
                  toggle
                  type="checkbox"
                  value={match.params.players}
                >
                  {["2", "3", "4", "5", "6", "7", "8", "9", "10"].map(
                    (value) => (
                      <ToggleButton
                        key={value}
                        type="radio"
                        checked={match.params.players === value}
                        value={value}
                      >
                        {match.params.players === value ? (
                          <a href="#done">{value}</a>
                        ) : (
                          <Link
                            to={
                              "/app/poktools/fastpok/form/" +
                              match.params.situation +
                              "/" +
                              value +
                              "/-1/-1/" +
                              match.params.stack +
                              "/" +
                              match.params.ante
                            }
                          >
                            {value}
                          </Link>
                        )}
                      </ToggleButton>
                    )
                  )}
                </ButtonGroup>
              </div>
              {match.params.situation === "call_push" ? (
                <>
                  <section>{t("poktools.fastpok.vilain.title")}</section>
                  <div
                    className={
                      "select-row" +
                      (match.params.positionVilain === "-1" ? " error" : "")
                    }
                  >
                    <ButtonGroup
                      toggle
                      type="checkbox"
                      value={match.params.positionVilain}
                    >
                      {getVilainPositionsForNbPlayers(
                        parseInt(match.params.players),
                        match.params.positionHero.replace("-1", "")
                      ).map((value) => (
                        <ToggleButton
                          key={value}
                          type="radio"
                          checked={match.params.positionVilain
                            .split(",")
                            .includes(value)}
                          value={value}
                        >
                          {match.params.positionVilain
                            .split(",")
                            .includes(value) ? (
                            match.params.positionVilain
                              .replace("-1", "")
                              .split(",").length === 2 ? (
                              <Link
                                to={
                                  "/app/poktools/fastpok/form/" +
                                  match.params.situation +
                                  "/" +
                                  match.params.players +
                                  "/" +
                                  match.params.positionVilain
                                    .replace(",", "")
                                    .replace(value, "") +
                                  "/-1/" +
                                  match.params.stack +
                                  "/" +
                                  match.params.ante
                                }
                              >
                                {value}
                              </Link>
                            ) : (
                              <Link
                                to={
                                  "/app/poktools/fastpok/form/" +
                                  match.params.situation +
                                  "/" +
                                  match.params.players +
                                  "/-1/-1/" +
                                  match.params.stack +
                                  "/" +
                                  match.params.ante
                                }
                              >
                                {value}
                              </Link>
                            )
                          ) : match.params.positionVilain.replace("-1", "")
                              .length === 0 ? (
                            <Link
                              to={
                                "/app/poktools/fastpok/form/" +
                                match.params.situation +
                                "/" +
                                match.params.players +
                                "/" +
                                value +
                                "/-1/" +
                                match.params.stack +
                                "/" +
                                match.params.ante
                              }
                            >
                              {value}
                            </Link>
                          ) : match.params.positionVilain
                              .replace("-1", "")
                              .split(",").length === 1 ? (
                            <Link
                              to={
                                "/app/poktools/fastpok/form/" +
                                match.params.situation +
                                "/" +
                                match.params.players +
                                "/" +
                                match.params.positionVilain.replace("-1", "") +
                                "," +
                                value +
                                "/-1/" +
                                match.params.stack +
                                "/" +
                                match.params.ante
                              }
                            >
                              {value}
                            </Link>
                          ) : (
                            <a href="#TOP" className="disabled" alt="">
                              {value}
                            </a>
                          )}
                        </ToggleButton>
                      ))}
                    </ButtonGroup>
                  </div>
                </>
              ) : (
                <></>
              )}

              <section>{t("poktools.fastpok.position.title")}</section>
              <div
                className={
                  "select-row" +
                  (match.params.positionHero === "-1" ? " error" : "")
                }
              >
                <ButtonGroup
                  toggle
                  type="checkbox"
                  value={match.params.positionHero}
                >
                  {(match.params.situation === "open_push"
                    ? getPositionsForNbPlayers(parseInt(match.params.players))
                    : getHeroPositionsForNbPlayers(
                        parseInt(match.params.players),
                        match.params.positionVilain.replace("-1", "")
                      )
                  ).map((value) => (
                    <ToggleButton
                      key={value}
                      type="radio"
                      checked={match.params.positionHero === value}
                      value={value}
                    >
                      {match.params.positionHero === value ? (
                        <Link
                          to={
                            "/app/poktools/fastpok/form/" +
                            match.params.situation +
                            "/" +
                            match.params.players +
                            "/" +
                            match.params.positionVilain +
                            "/-1/" +
                            match.params.stack +
                            "/" +
                            match.params.ante
                          }
                        >
                          {value}
                        </Link>
                      ) : (
                        <Link
                          to={
                            "/app/poktools/fastpok/form/" +
                            match.params.situation +
                            "/" +
                            match.params.players +
                            "/" +
                            match.params.positionVilain +
                            "/" +
                            value +
                            "/" +
                            match.params.stack +
                            "/" +
                            match.params.ante
                          }
                        >
                          {value}
                        </Link>
                      )}
                    </ToggleButton>
                  ))}
                </ButtonGroup>
              </div>
              <section>{t("poktools.fastpok.stack.title")}</section>
              <div className={"stack-container"}>
                <div
                  className={
                    "select-row" + (match.params.stack < 2 ? " error" : "")
                  }
                >
                  <div className="stack-range">
                    <RangeSlider
                      min={2}
                      max={20}
                      step={0.1}
                      value={match.params.stack}
                      tooltipPlacement="top"
                      onChange={(value) =>
                        handleStackChange(value.target.value)
                      }
                    ></RangeSlider>
                    <div className="stack-custom">
                      <div className="stack-label">Stack :&nbsp;</div>
                      <InputGroup>
                        <FormControl
                          aria-label="Stack in BB"
                          type="number"
                          min={0}
                          max={20}
                          value={match.params.stack}
                          onChange={(value) =>
                            handleStackChange(value.target.value)
                          }
                          onBlur={(value) => {
                            console.log("blur", value.target);
                            if (match.params.stack > 2) {
                              handleStackChange(20);
                            }
                          }}
                        />
                      </InputGroup>
                    </div>
                  </div>
                </div>
                <div className="select-row">
                  <ButtonGroup
                    toggle
                    type="checkbox"
                    value={match.params.stack}
                  >
                    {[5, 7.5, 10, 15, 20].map((value) => (
                      <ToggleButton
                        key={value}
                        type="radio"
                        checked={match.params.stack === "" + value}
                        value={value}
                      >
                        {match.params.players === value ? (
                          value + " BB"
                        ) : (
                          <Link
                            to={
                              "/app/poktools/fastpok/form/" +
                              match.params.situation +
                              "/" +
                              match.params.players +
                              "/" +
                              match.params.positionVilain +
                              "/" +
                              match.params.positionHero +
                              "/" +
                              value +
                              "/" +
                              match.params.ante
                            }
                          >
                            {value} BB
                          </Link>
                        )}
                      </ToggleButton>
                    ))}
                  </ButtonGroup>
                </div>
              </div>
              <section>{t("poktools.fastpok.ante.title")}</section>
              <div className="ante-container">
                <div className="select-row">
                  <div className="ante-range">
                    <RangeSlider
                      min={0}
                      max={25}
                      step={0.1}
                      value={match.params.ante}
                      tooltipPlacement="top"
                      onChange={(value) => handleAnteChange(value.target.value)}
                    ></RangeSlider>
                    <div className="ante-custom">
                      <div className="ante-label">Ante :&nbsp;</div>
                      <InputGroup>
                        <FormControl
                          aria-label="Ante in BB %"
                          value={match.params.ante}
                          type="number"
                          min={0}
                          onChange={(value) =>
                            handleAnteChange(value.target.value)
                          }
                        />
                      </InputGroup>
                    </div>
                  </div>
                </div>
                <div className="select-row">
                  <ButtonGroup toggle type="checkbox" value={match.params.ante}>
                    {[0, 5, 10, 12.5, 15, 25].map((value) => (
                      <ToggleButton
                        key={value}
                        type="radio"
                        checked={match.params.ante === "" + value}
                        value={value}
                      >
                        {match.params.ante === value ? (
                          value + " %"
                        ) : (
                          <Link
                            to={
                              "/app/poktools/fastpok/form/" +
                              match.params.situation +
                              "/" +
                              match.params.players +
                              "/" +
                              match.params.positionVilain +
                              "/" +
                              match.params.positionHero +
                              "/" +
                              match.params.stack +
                              "/" +
                              value
                            }
                          >
                            {value} %
                          </Link>
                        )}
                      </ToggleButton>
                    ))}
                  </ButtonGroup>
                </div>
              </div>
              <section>
                <Button
                  onClick={analyseData}
                  disabled={
                    match.params.stack < 2 ||
                    match.params.positionHero === "-1" ||
                    (match.params.situation === "call_push" &&
                      match.params.positionVilain === "-1")
                  }
                >
                  {t("poktools.fastpok.analysis.title")}
                </Button>
              </section>
            </Form>
            {data.length > 0 ? (
              <div className="results">
                <div className="analysis">
                  <div className="range">
                    {situation === "open_push" ? "Open Push" : "Call vs Push"} -{" "}
                    {t("poktools.trainer.hero")} {positionHero}
                    {situation === "call_push" ? (
                      <>
                        &nbsp;- {t("poktools.trainer.vilain")} {positionVilain}
                      </>
                    ) : (
                      <></>
                    )}
                    <br /> {players} {t("poktools.fastpok.players.short")} -
                    Stack {nFormatter(stack)} - Ante {nFormatter(ante)}
                  </div>
                </div>
                {data.map((row, index) => (
                  <div className="row" key={index}>
                    {row.map((cell, cellIndex) => (
                      <div
                        key={cellIndex}
                        className="cell"
                        style={{
                          backgroundColor:
                            cell === selectedCell ? "#000" : cell.color,
                          color:
                            cell === selectedCell
                              ? "#FFF"
                              : getCellForeground(cell.color)
                        }}
                        onMouseOver={() => doSetSelectedCell(cell)}
                      >
                        <span
                          className={"cards" + (cell.ev > 0 ? " positiv" : "")}
                        >
                          {cell.hand}
                        </span>
                        <span className="ev">{nFormatter(cell.ev)}</span>
                      </div>
                    ))}
                  </div>
                ))}
                <div className="analysis">
                  <div className="range">Range : {range}</div>
                  <div className="details">
                    <div className="result-cards">
                      &nbsp;
                      {selectedCards.map((card, index) => (
                        <img key={index} src={Cards["card" + card]} alt="" />
                      ))}
                      &nbsp;
                    </div>
                    <div className="column">
                      <div className="result-title">
                        &nbsp;
                        {selectedCell !== null ? "Expected Value" : ""}
                        &nbsp;
                      </div>
                      {situation === "open_push" ? (
                        <div className="result-title">
                          &nbsp;
                          {selectedCell !== null ? "Fold equity" : ""}
                          &nbsp;
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                    <div className="column">
                      <div width="100%" className="result-value">
                        {selectedCell !== null ? selectedCell.ev + " BB" : ""}
                      </div>
                      {situation === "open_push" ? (
                        <div
                          width="100%"
                          className="result-value"
                          style={{
                            color:
                              selectedCell !== null ? selectedCell.color : ""
                          }}
                        >
                          {selectedCell !== null ? selectedCell.fe : ""}
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="no-data">
                {t("poktools.fastpok.analysis.nodata")}
              </div>
            )}
          </div>
        </div>
      </PerfectScrollbar>
    </div>
  );
}
export default FastPok;
